/***
*
*   API Key Editor
*   Create or edit a new/existing API key
*
**********/

import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Animate, Card, Form, Message, Breadcrumbs, TextInput, Loader, History, useAPI } from 'components/lib';
import AccountNav from '../nav';
export function APIKeyEditor(props){

  const { id: accountId } = useParams();
  
  // get the scopes
  const scopes = useAPI('/api/scopes');

  // state
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [newAPIKey, setNewAPIKey] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [accountLoading, setAccountLoading] = useState(true);

  const fetch = useCallback(async () => {

    setLoading(true);
    const res = await axios.get(`/api/account/${accountId}/key/${props?.location?.search?.substring(4)}`);
    res.data.data.length ? setData(res.data.data[0]) : History.push('/404');
    setLoading(false);

  }, [props.location.search, accountId]);

  const checkAccountType = useCallback(async () => {
    try {
      // Get account information to check monitoring level
      const response = await axios.get('/api/user/associatedDataConnections');
      const accounts = response.data.data;
      const currentAccount = accounts.find(acc => acc.id === accountId);
      
      if (currentAccount) {
        setAccountType(currentAccount.account_type || 'health_score_only');
      }
      setAccountLoading(false);
    } catch (error) {
      console.error('Error fetching account info:', error);
      setAccountLoading(false);
    }
  }, [accountId]);

  useEffect(() => {
    checkAccountType();
  }, [accountId, checkAccountType]);

  useEffect(() => {

    // editing existing key?
    const id = props?.location?.search;
    if (id) fetch(id);

  }, [fetch, props.location.search])

  // Redirect health score only accounts
  if (!accountLoading && accountType === 'health_score_only') {
    History.push(`/account/${accountId}`);
    return null;
  }

  if (scopes.loading || accountLoading)
    return <Loader />

  return (
    <Animate>
      <AccountNav/>

      <Breadcrumbs items={[
        { name: 'API Keys', url: `/account/${accountId}/apikeys` },
        { name: `${data ? 'Edit': 'Create'} API Key`, url: `/account/${accountId}/apikeys/create` }
      ]}/>

      { newAPIKey ? 
        <Message 
          closable
          title='Your New API Key'
          type='warning'
          buttonText='Back to API Keys'
          buttonLink={`/account/${accountId}/apikeys`}
          text='Your API key is below. Please store this somewhere safe.'>

            <TextInput value={ newAPIKey } />

        </Message>  : 
 
        <Card title={ `${data ? 'Edit': 'Create'} API Key` } loading={ loading }> 
          <Form 
            data={{
              name: {
                label: 'Name',
                type: 'text',
                required: true,
                value: data.name, 
                errorMessage: 'Please provide a descriptive name for your key.' 
              },
              scope: {
                type: 'checkbox',
                label: 'Scope',
                required: true,
                min: 1,
                default: data.scope,
                options: scopes?.data,
                errorMessage: 'Please select at least one scope' 
              }
            }}
            url={ data ? `/api/account/${accountId}/key/${data.id}` : `/api/account/${accountId}/key` }
            method={ data ? 'PATCH' : 'POST' }
            buttonText={ data ? 'Save Changes' : 'Create New API Key' }
            callback={ res => {
              
              !data && setNewAPIKey(res?.data?.data?.full_key) 
            
            }}
          />
        </Card>
        }
    </Animate>
  )
}